import { permissions } from '@mpk/shared/domain';

enum DocumentManagementOrganizationSettingsPermissionsEnum {
  None = 0,

  /**
   * Manage the organization settings for the purchase requisition.
   */
  ManageSettings = 1,
}

export const DocumentManagementOrganizationSettingsPermissions = permissions(
  DocumentManagementOrganizationSettingsPermissionsEnum,
  {
    featureId: 'ModuleSettings',
  },
);
